import React, { useEffect, useMemo } from 'react'
import { CloseCircleOutlined, CheckCircleOutlined } from '@ant-design/icons'

export default function PasswordRequirements({ password, confirmPassword, onRequirementsChange }) {
 const requirements = useMemo(() => [
   {
     text: 'At least 8 characters long', 
     test: (pwd) => pwd?.length >= 8,
   },
   {
     text: 'Contains uppercase letter',
     test: (pwd) => pwd && /[A-Z]/.test(pwd),
   },
   {
     text: 'Contains lowercase letter',
     test: (pwd) => pwd && /[a-z]/.test(pwd),
   },
   {
     text: 'Contains number',
     test: (pwd) => pwd && /[0-9]/.test(pwd),
   },
   {
     text: 'Contains special character (!@#$%^&*)',
     test: (pwd) => pwd && /[!@#$%^&*]/.test(pwd),
   },
   {
     text: 'Passwords match',
     test: (pwd) => confirmPassword && pwd === confirmPassword,
   },
 ], [confirmPassword])

 useEffect(() => {
   const allMet = requirements.every(req => req.test(password)) && password === confirmPassword
   onRequirementsChange(allMet)
 }, [password, confirmPassword, onRequirementsChange, requirements])

 return (
   <div style={{ marginTop: '0.5rem' }}>
     <ul style={{
       listStyle: 'none',
       marginTop: '0.25rem',
       paddingLeft: 0,
       marginLeft: '4px',
     }}>
       {requirements.map((req, index) => (
         <li key={index} style={{
           display: 'flex',
           alignItems: 'center',
           marginBottom: '0.25rem',
         }}>
           {req.test(password) ? (
             <CheckCircleOutlined
               style={{
                 fontSize: '18px',
                 color: '#198754',
                 marginRight: '0.5rem',
               }}
             />
           ) : (
             <CloseCircleOutlined
               style={{
                 fontSize: '18px',
                 color: '#dc3545',
                 marginRight: '0.5rem',
               }}
             />
           )}
           <span>{req.text}</span>
         </li>
       ))}
     </ul>
   </div>
 )
}